import { services } from '../../../../constants/services';
import { remove, DeleteResponse } from '../../../../utils/api';

export class DeleteWidgetsService {
  async run(id: string | number): Promise<DeleteResponse> {
    return remove(`${services['chat-instances']}`, id);
  }
}
